<div class="block">
  @if (data) {
    <div  class="assignAccountsCountText left" ><span id="accountsrowcount">{{rowCount}}</span> assigned accounts</div>
  }
  <button label="Assign Accounts" class="btn-medium-secondary" (click)="showAssignAccountsDialog()" [disabled]="isUnAuthorized">Assign Accounts</button>
</div>
@if (!isUiTest) {
  <irb-inventory-grid
    [style.width] = "'100%'"
    [gridHeight]="'200px'"
    [showSideBar] = "false"
    [gridOptions] = "gridOptions"
    [frameworkComponents] = 'frameworkComponents'
  (gridReady) = "onGridReady($event)"></irb-inventory-grid>
}

<ng-template #accountNumberOverlay>
  @if (row) {
    <div style="min-width: 150px;">
      <div class="hblock" style="color: #999; font-size: 11px;">Go to SAC</div>
      <div style="padding-left: 10px">
        @for (item of sacMenuItems; track item) {
          <div class="hblock clickable" (click)="openSACWithContext(item.sanc); closeMenu(); $event.stopPropagation();">
            {{item.label}} <i class="material-icons" style="font-size: 16px; color: #666; float: right;">open_in_new</i>
          </div>
        }
      </div>
    </div>
  }
</ng-template>
